import * as Sentry from "@sentry/react";
import React from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";
import { env } from "@/src/common/constants/env";

Sentry.init({
	dsn: env.SENTRY_DSN,
	environment: env.MODE,
	enabled: !!env.SENTRY_DSN && env.MODE !== "development",
	integrations: [
		Sentry.reactRouterV7BrowserTracingIntegration({
			useEffect: React.useEffect,
			useLocation,
			useNavigationType,
			createRoutesFromChildren,
			matchRoutes,
		}),
		Sentry.replayIntegration(),
	],
	tracesSampleRate: env.MODE === "production" ? 0.2 : 1.0,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

export { Sentry };
